import Icon from '../components/Icon.vue'

Icon.register({
  'caret-square-right': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M48 32h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48zM188.5 387.5l123-123c4.7-4.7 4.7-12.3 0-17l-123-123c-7.6-7.6-20.5-2.2-20.5 8.5v246.1c0 10.7 12.9 16 20.5 8.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/caret-square-right.js
// module id = 1155
// module chunks = 0